// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.note-list-container-parent {
  position: absolute;
  top: 75px;
  left: 200px;
  width: calc(100% - 200px);
  height: calc(100% - 75px);
  overflow: hidden;
}
.note-list-filter-label {
  font-size: 15px;
  font-weight: 500;
  margin-right: 10px;
}
.note-list-header {
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/lists/noteList/noteList.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;AACf","sourcesContent":[".note-list-container-parent {\n  position: absolute;\n  top: 75px;\n  left: 200px;\n  width: calc(100% - 200px);\n  height: calc(100% - 75px);\n  overflow: hidden;\n}\n.note-list-filter-label {\n  font-size: 15px;\n  font-weight: 500;\n  margin-right: 10px;\n}\n.note-list-header {\n  display: flex;\n  /* align-items: center; */\n  justify-content: space-between;\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
